import { APP_VERSION, BUILD_TIME, GIT_SHA, formatBuildTime } from "../utils/appVersion";

const AppVersionBadge = () => {
  const formattedBuildTime = formatBuildTime(BUILD_TIME);

  return (
    <div
      className="mt-auto px-4 pb-2 text-[11px] leading-relaxed text-gray-500"
      title="Deployed frontend version (auto-increments on each CI deploy)"
    >
      <p className="font-semibold text-gray-600">
        v{APP_VERSION}
        {GIT_SHA ? (
          <span className="font-normal text-gray-400"> · {GIT_SHA}</span>
        ) : null}
      </p>
      {formattedBuildTime && <p>Built {formattedBuildTime}</p>}
    </div>
  );
};

export default AppVersionBadge;
